import { assign, createMachine } from "xstate"

const initialContext = {
  loadingDocs: false,
  catalogoDocs: [],
  catalogo_xniveleducativo: [],
  docs_xpersona: [],
  id_Relacion_Persona_Documento: 0,
  documento: "",
  error: "",
  refreshListaDocs: false,
  notificacion: "",
  uploadDoc: null,
}

const documentosMachine = createMachine(
  {
    predictableActionArguments: true,
    context: initialContext,
    id: "documentos",
    initial: "idle",
    states: {
      idle: {
        on: {
          "documentos/UPLOAD_FILE": {
            actions: ["setLoading"],
            target: "idle",
          },
          "documentos/UPLOAD_FILE_SUCCESS": {
            actions: [
              "setUploadDoc",
              "setNotificacionUploadOk",
              "unsetLoading",
              "unsetError",
            ],
            target: "idle",
          },
          "documentos/UPLOAD_FILE_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "documentos/SET_IDRELPERDOC": {
            actions: ["setid_Relacion_Persona_Documento"],
            target: "idle",
          },
          "documentos/UNSET_REFRESH": {
            actions: ["unsetRefreshListaDocs"],
            target: "idle",
          },
          "documentos/UNSET_NOTIFICACION": {
            actions: ["unsetNotificacion"],
            target: "idle",
          },
          "documentos/GET_DOCUMENTACION": {
            actions: ["setLoadingDocs", "unsetError"],
            target: "idle",
          },
          "documentos/GET_DOCUMENTACION_SUCCESS": {
            actions: [
              "setCatalogoDocs",
              "setCatalogo_xniveleducativo",
              "setDocs_xpersona",
              "unsetLoadingDocs",
              "unsetError",
            ],
            target: "idle",
          },
          "documentos/GET_DOCUMENTACION_FAIL": {
            actions: ["setError", "unsetLoadingDocs"],
            target: "idle",
          },
          "documentos/GET_DOCUMENTO": {
            actions: ["setLoadingDocs", "unsetError"],
            target: "idle",
          },
          "documentos/GET_DOCUMENTO_SUCCESS": {
            actions: ["setDocumento", "unsetLoadingDocs", "unsetError"],
            target: "idle",
          },
          "documentos/GET_DOCUMENTO_FAIL": {
            actions: ["setError", "unsetLoadingDocs"],
            target: "idle",
          },
          "documentos/ADD_DOCUMENTO": {
            actions: ["setLoadingDocs", "unsetError"],
            target: "idle",
          },
          "documentos/ADD_DOCUMENTO_SUCCESS": {
            actions: [
              // "setDocumento", Al refrescarse la lista se trae de nuevo
              "unsetLoadingDocs",
              "unsetError",
              "setRefreshListaDocs",
            ],
            target: "idle",
          },
          "documentos/ADD_DOCUMENTO_FAIL": {
            actions: ["setError", "unsetLoadingDocs"],
            target: "idle",
          },
          "documentos/UPDATE_DOCUMENTO": {
            actions: ["setLoadingDocs", "unsetError"],
            target: "idle",
          },
          "documentos/UPDATE_DOCUMENTO_SUCCESS": {
            actions: [
              "setRefreshListaDocs",
              // "setDocumento",
              "unsetLoadingDocs",
              "unsetError",
            ],
            target: "idle",
          },
          "documentos/UPDATE_DOCUMENTO_FAIL": {
            actions: ["setError", "unsetLoadingDocs"],
            target: "idle",
          },
          "documentos/DEL_DOCUMENTO": {
            actions: ["setLoadingDocs", "unsetError"],
            target: "idle",
          },
          "documentos/DEL_DOCUMENTO_SUCCESS": {
            actions: ["setRefreshListaDocs", "unsetLoadingDocs", "unsetError"],
            target: "idle",
          },
          "documentos/DEL_DOCUMENTO_FAIL": {
            actions: ["setError", "unsetLoadingDocs"],
            target: "idle",
          },
          "documentos/UPDATE_LISTADOCUMENTOS": {
            actions: ["setLoadingDocs", "unsetError"],
            target: "idle",
          },
          "documentos/UPDATE_LISTADOCUMENTOS_SUCCESS": {
            actions: [
              //"setRefreshListaDocs",
              // "setDocumento",
              "unsetLoadingDocs",
              "unsetError",
            ],
            target: "idle",
          },
          "documentos/UPDATE_LISTADOCUMENTOS_FAIL": {
            actions: ["setRefreshListaDocs", "setError", "unsetLoadingDocs"],
            target: "idle",
          },
        },
      },
    },
  },
  {
    actions: {
      resetMachine: assign(initialContext),
      setNotificacion: assign({
        notificacion: (_, event) => event.payload.data,
      }),
      setNotificacionOk: assign({
        notificacion: "Todo Ok",
      }),
      setNotificacionUploadOk: assign({
        notificacion: "Archivo grabado con éxito",
      }),
      unsetNotificacion: assign({
        notificacion: "",
      }),
      setRefreshListaDocs: assign({
        refreshListaDocs: true,
      }),
      unsetRefreshListaDocs: assign({
        refreshListaDocs: false,
      }),
      setid_Relacion_Persona_Documento: assign({
        id_Relacion_Persona_Documento: (_, event) => {
          console.log("data", event.payload.data)
          return event.payload.data
        },
      }),
      setCatalogoDocs: assign({
        catalogoDocs: (_, event) => event.payload.data.Catalogo,
      }),
      setCatalogo_xniveleducativo: assign({
        catalogo_xniveleducativo: (_, event) =>
          event.payload.data.xNivelEducativo,
      }),
      setDocs_xpersona: assign({
        docs_xpersona: (_, event) => event.payload.data.xPersona,
      }),
      setDocumento: assign({
        documento: (_, event) => event.payload.data,
      }),
      unsetDocumento: assign({
        documento: null,
      }),
      setUploadDoc: assign({
        uploadDoc: (_, event) => event.payload.data,
      }),
      unsetUploadDoc: assign({
        uploadDoc: null,
      }),
      setError: assign({
        error: (_, event) => {
          console.log(event.payload)
          return event.payload.response?.data?.Mensaje_Error
            ? event.payload.response?.data?.Mensaje_Error
            : event.payload.message
            ? event.payload.message
            : "Ocurrió un error!"
        },
      }),
      unsetError: assign({
        error: null,
      }),
      setLoadingDocs: assign({
        loadingDocs: true,
      }),
      unsetLoadingDocs: assign({
        loadingDocs: false,
      }),
    },
  }
)

export default documentosMachine
